import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Marketing pages bring their own <style> blocks via the imported HTML,
// so we only need tokens + reset + app-interior styles here.
import './styles/tokens.css';
import './styles/reset.css';
import './styles/app.css';
import './styles/tournaments.css';
import './styles/broadcast.css';

import App from './App';
import { useAuthStore } from './store/authStore';

// Hydrate before any route renders. Public invite previews start requests in
// child effects, which run before a parent App effect would restore the session.
useAuthStore.getState().loadFromStorage();
const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
